(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buenzli-raclette-herbst"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', function(event) {
  if (!event.target.matches('.brc-variant')) return;
  var card = event.target.closest('.brc-card');
  var option = event.target.selectedOptions[0];
  var price = card && card.querySelector('[data-brc-price]');
  if (price && option) price.textContent = option.dataset.price;
});

  } catch(e) { console.error(e); }
})();
})();
